var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62,
    height: 64,
    viewBox: "0 0 62 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.642,
    y1: 0.015,
    x2: 0.301,
    y2: 0.805,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4002f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#cf003c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0804b5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Expertise_and_Experience",
    "data-name": "Expertise and Experience",
    transform: "translate(-215.854 -2128.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9704",
    "data-name": "Path 9704",
    d: "M794.78,735.359c8.272,8.111,10.911,17.959,8.331,28.879-3.394,14.361-12.366,23.806-26.946,27.138C756.657,795.833,740.4,779.957,742.2,761c1.4-14.762,9.115-25.286,22.948-30.641C775.732,726.261,785.832,727.761,794.78,735.359Z",
    transform: "translate(-526.207 1400.468)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9768",
    "data-name": "Path 9768",
    d: "M18.462,2h0A.533.533,0,0,1,19,2.533V5.2a.533.533,0,0,1-.533.533h0a.533.533,0,0,1-.533-.533V2.533A.533.533,0,0,1,18.462,2ZM9.413,9.172a.533.533,0,1,0,.754-.754L8.281,6.533a.533.533,0,1,0-.754.754ZM6.2,16.937H3.533a.533.533,0,0,0,0,1.067H6.2a.533.533,0,0,0,0-1.067Zm21.32,8.824a.533.533,0,1,0-.754.754L28.652,28.4a.533.533,0,1,0,.754-.754Zm-18.107,0L7.527,27.646a.533.533,0,1,0,.754.754l1.886-1.885a.533.533,0,1,0-.754-.754ZM33.4,16.929H30.733a.533.533,0,0,0,0,1.067H33.4a.533.533,0,0,0,0-1.067ZM27.138,9.323a.532.532,0,0,0,.377-.156L29.4,7.281a.533.533,0,1,0-.755-.754L26.761,8.413a.533.533,0,0,0,.377.91Zm-.466,11.938a9.587,9.587,0,0,0-.151-9.218,9.166,9.166,0,0,0-7.46-4.693h0a10.775,10.775,0,0,0-1.189,0,9.166,9.166,0,0,0-7.46,4.693,9.587,9.587,0,0,0-.151,9.218l3.405,6.47v2.535A3.738,3.738,0,0,0,17.4,34c4.194,0,5.864-1.672,5.867-3.733V27.732ZM14.733,29.733v-1.6H22.2v1.6ZM11.341,12.568a8,8,0,0,1,6.592-4.153,9.61,9.61,0,0,1,1.068,0,8,8,0,0,1,6.593,4.153,8.526,8.526,0,0,1,.136,8.2l-3.317,6.3h-7.89l-3.317-6.3a8.526,8.526,0,0,1,.136-8.2Zm8.193,20.365H17.4A2.671,2.671,0,0,1,14.787,30.8h7.359A2.671,2.671,0,0,1,19.533,32.933Z",
    transform: "translate(226.854 2141.601)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.8b8fa11ad0d4dff3ae595e726b7bedfa.svg";
export { ForwardRef as ReactComponent };